import React, { memo } from 'react';
import PropTypes from 'prop-types';
import './unreadBadge.scss';

const UnreadBadge = ({ count, className = '' }) => {
   if (!count || count <= 0) return null;
   return <span className={`chat-unread-badge ct-flexCenter ${className}`}>{count > 99 ? '99+' : count}</span>;
};

UnreadBadge.displayName = 'UnreadBadge';

UnreadBadge.propTypes = {
   count: PropTypes.number,
   className: PropTypes.string,
};

export default memo(UnreadBadge);
